import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { CTAButton, PageHero, SectionLabel } from '../components/shared';
import { services } from '../data/site';
export function Services() {
  return <>
      <PageHero eyebrow="Core solutions" title="One security partner for the whole property." subtitle="Cameras, alarms, access control, smart automation, and ongoing support — all from one local team." data-id="element-499">
        <CTAButton to="/assessment" data-id="element-500">Free assessment</CTAButton>
      </PageHero>

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8" data-id="element-501">
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-502">
          {services.map(s => {
          const Icon = s.icon;
          const to = s.slug === 'smart-home' ? '/smart-home' : `/services/${s.slug}`;
          return <Link key={s.slug} to={to} className="group block rounded-[2rem] border border-slate-200 bg-slate-50 p-7 transition hover:-translate-y-1 hover:bg-slate-950 hover:text-white hover:shadow-2xl" data-id="element-503">
                <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-sky-500 shadow-sm group-hover:bg-sky-400 group-hover:text-slate-950" data-id="element-504">
                  <Icon className="h-7 w-7" data-id="element-505" />
                </div>
                <h3 className="text-2xl font-black" data-id="element-506">{s.title}</h3>
                <p className="mt-3 leading-7 text-slate-600 group-hover:text-slate-300" data-id="element-507">
                  {s.short}
                </p>
                <span className="mt-5 inline-flex items-center gap-1 text-sm font-black text-sky-600 group-hover:text-sky-300 group-hover:gap-2" data-id="element-508">
                  Learn more <ArrowRight className="h-4 w-4" data-id="element-509" />
                </span>
              </Link>;
        })}
        </div>
      </section>

      <section className="bg-sky-50 py-16" data-id="element-510">
        <div className="mx-auto max-w-5xl px-4 text-center sm:px-6 lg:px-8" data-id="element-511">
          <SectionLabel data-id="element-512">Not sure where to start?</SectionLabel>
          <h2 className="text-3xl font-black sm:text-4xl" data-id="element-513">
            We will design the right combination for your property.
          </h2>
          <div className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-514">
            <CTAButton to="/assessment" data-id="element-515">Get my free assessment</CTAButton>
            <CTAButton variant="dark" to="/contact" data-id="element-516">
              Talk to a specialist
            </CTAButton>
          </div>
        </div>
      </section>
    </>;
}